module.exports = __webpack_public_path__ + "static/img/fh-banner1.c1f88ff7.png";